// src/stores/Savabegh.js

import { ref } from "vue";
import { defineStore } from "pinia";
import { useToast } from "vue-toastification";
import apiClient from '@/axios';

const toast = useToast();

export const useSavabeghStore = defineStore("Savabegh", () => {
  const SavabeghList = ref([]);
  const pagination = ref({ total: 0, current_page: 1, per_page: 20 });
  const searchQuery = ref("");

  async function addSavabegh(savabeghData) {
    try {
      const response = await apiClient.post('/Savabegh', savabeghData);

      if (response.status === 200) {
        toast.success("سابقه با موفقیت ثبت شد");
        searchQuery.value = "";
      } else {
        toast.error("خطا در ثبت اطلاعات سابقه");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error adding Savabegh:", error);
      toast.error("خطا در ثبت اطلاعات سابقه");
    }
  }
  async function updateSavabegh(input) {
    try {
      const response = await apiClient.put('/Savabegh', input);
      if (response.status === 200) {
        toast.success("سابقه با موفقیت ویرایش شد");
      } else {
        toast.error("خطا در ویرایش سابقه");
        console.error(response.data);
      }
    } catch (error) {
      console.error("Error updating doctor:", error);
      toast.error("خطا در ویرایش سابقه");
    }
  }

  return {
    SavabeghList,
    pagination,
    searchQuery,
    addSavabegh,
    updateSavabegh
  };
});
